<template>
	<div class="row">
		<div class="col-3 text-center">
			<img :src="logo" class="img-thumbnail" :alt="nomeAssistencia" />
		</div>
		<div class="col-6 align-self-center p-0">
			<b>{{ nomeAssistencia }}</b>
		</div>
		<div class="col-3 text-center p-0 align-self-center" style="font-size: 12px">
			<button type="button" class="btn btn-default" @click="abreAjuda">
				<span class="material-symbols-outlined">help</span>
				<br />
				Ajuda?
			</button>
		</div>
	</div>
</template>

<script setup>
import {defineProps} from 'vue';
defineProps({
	logo: String,
	nomeAssistencia: String,
});

function abreAjuda() {
	if (!document.getElementById("contato").checkVisibility()) {
		document.getElementById('abrir-contato').click();
	}
	if (!document.getElementById("cancelar").checkVisibility()) {
		document.getElementById('abrir-cancelar').click();
	}
	setTimeout(() => {
		document.getElementById('ajuda').scrollIntoView({block: "end", behavior: "smooth"});  
	}, 200);
}
    
</script>